// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Util_Nullable = require("../util/Util_Nullable.bs.js");
var $$Date = require("@artegeie/date");
var Type_Translation = require("../generated/Type_Translation.bs.js");

function changeLocale(language) {
  return {
          NAME: "ChangeLocaleStr",
          VAL: language
        };
}

function defaultNextEpisode(param) {
  var season = param.season;
  var progress = param.progress;
  var match = progress > 15;
  var match$1 = progress < 95;
  var labelAction = match && match$1 ? "Continue watching" : "Watch";
  var labelSeason = season !== 0 ? " : season " + String(season) : "";
  return labelAction + labelSeason + " (" + String(param.episode) + "/" + String(param.totalEpisodes) + ")";
}

function defaultFormaters_addFavorite(title) {
  return "Add " + (title + " to my favorites");
}

function defaultFormaters_availabilityDate(param) {
  return "date: " + param.start.toLocaleDateString();
}

function defaultFormaters_betweenDates(param) {
  return "from " + param.start.toLocaleDateString() + " to " + param.end_.toLocaleDateString();
}

function defaultFormaters_date(prim) {
  return prim.toLocaleString();
}

function defaultFormaters_dateWithFormat(date, format) {
  return $$Date.format(date, format);
}

function defaultFormaters_nextBroadcastDate(date) {
  return date.toLocaleDateString();
}

function defaultFormaters_progress(progress) {
  return "progress: " + (progress.toString() + "%");
}

function defaultFormaters_removeFavorite(title) {
  return "Remove " + (title + " from my favorites");
}

function defaultFormaters_watchTrailer(title) {
  return "Watch " + (title + " trailer");
}

function defaultFormaters_weekInterval(date) {
  return "Week of " + date.toDateString();
}

function defaultFormaters_infoSelectedDay(selectionDate, daysBefore, daysAfter) {
  return "Votre sélection actuelle : " + selectionDate + ". Vous pouvez consulter les programmes des " + daysBefore + " jours avant et des " + daysAfter + " jours après cette date.";
}

function defaultFormaters_formValidationStringMin(min) {
  return "Le champ doit comporter au moins " + String(min) + " caractères";
}

function defaultFormaters_formValidationStringMax(max) {
  return "Le champ ne doit pas dépasser " + String(max) + " caractères";
}

var defaultFormaters = {
  addFavorite: defaultFormaters_addFavorite,
  availabilityDate: defaultFormaters_availabilityDate,
  betweenDates: defaultFormaters_betweenDates,
  date: defaultFormaters_date,
  dateWithFormat: defaultFormaters_dateWithFormat,
  nextBroadcastDate: defaultFormaters_nextBroadcastDate,
  nextEpisode: defaultNextEpisode,
  progress: defaultFormaters_progress,
  removeFavorite: defaultFormaters_removeFavorite,
  watchTrailer: defaultFormaters_watchTrailer,
  weekInterval: defaultFormaters_weekInterval,
  infoSelectedDay: defaultFormaters_infoSelectedDay,
  formValidationStringMin: defaultFormaters_formValidationStringMin,
  formValidationStringMax: defaultFormaters_formValidationStringMax
};

function ensureFormaters(formaters) {
  return {
          addFavorite: Util_Nullable.getOrElse(defaultFormaters_addFavorite, formaters.addFavorite),
          availabilityDate: Util_Nullable.getOrElse(defaultFormaters_availabilityDate, formaters.availabilityDate),
          betweenDates: Util_Nullable.getOrElse(defaultFormaters_betweenDates, formaters.betweenDates),
          date: Util_Nullable.getOrElse(defaultFormaters_date, formaters.date),
          dateWithFormat: Util_Nullable.getOrElse(defaultFormaters_dateWithFormat, formaters.dateWithFormat),
          nextBroadcastDate: Util_Nullable.getOrElse(defaultFormaters_nextBroadcastDate, formaters.nextBroadcastDate),
          nextEpisode: Util_Nullable.getOrElse(defaultNextEpisode, formaters.nextEpisode),
          progress: Util_Nullable.getOrElse(defaultFormaters_progress, formaters.progress),
          removeFavorite: Util_Nullable.getOrElse(defaultFormaters_removeFavorite, formaters.removeFavorite),
          watchTrailer: Util_Nullable.getOrElse(defaultFormaters_watchTrailer, formaters.watchTrailer),
          weekInterval: Util_Nullable.getOrElse(defaultFormaters_weekInterval, formaters.weekInterval),
          infoSelectedDay: Util_Nullable.getOrElse(defaultFormaters_infoSelectedDay, formaters.infoSelectedDay),
          formValidationStringMin: Util_Nullable.getOrElse(defaultFormaters_formValidationStringMin, formaters.formValidationStringMin),
          formValidationStringMax: Util_Nullable.getOrElse(defaultFormaters_formValidationStringMax, formaters.formValidationStringMax)
        };
}

var defaultAlternativeLanguages = [];

function ensureAlternativeLanguages(alternativeLanguages) {
  return Util_Nullable.getOrElse(defaultAlternativeLanguages, alternativeLanguages);
}

var initialState = {
  formaters: defaultFormaters,
  labels: Type_Translation.$$default,
  locale: /* Fr */0,
  myArteUrl: "https://my.arte.tv",
  loginUrl: "https://my.arte.tv/index.php?lang=fr#section/landing",
  profileUrl: "https://www.arte.tv/fr/profile"
};

exports.changeLocale = changeLocale;
exports.defaultNextEpisode = defaultNextEpisode;
exports.defaultFormaters = defaultFormaters;
exports.ensureFormaters = ensureFormaters;
exports.defaultAlternativeLanguages = defaultAlternativeLanguages;
exports.ensureAlternativeLanguages = ensureAlternativeLanguages;
exports.initialState = initialState;
/* @artegeie/date Not a pure module */
